<template>
  <div class="relative">
      <button
        @click="toggleDropdown"
        class="inline-flex items-center px-4 py-2 text-white font-medium rounded focus:outline-none"
        :class="[isCitizenM ? 'bg-black border border-white hover:bg-citizenM-900 transition-colors duration-200' : 'bg-blue-600 hover:bg-blue-700']"
      >
        Account
        <svg
          class="ml-2 h-4 w-4 transform transition-transform duration-150 ease-in-out"
          :class="{'rotate-180': showDropdown}"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path fill-rule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z"
                clip-rule="evenodd" />
        </svg>
      </button>
      <div
        v-if="showDropdown"
        class="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg z-50"
      >
        <router-link @click="logoutFromKeycloak" :to="{name: 'logout'}" class="block p-3 pl-2 text-lg text-gray-800 hover:bg-gray-100" data-test="logout">
          Logout
        </router-link>
        <router-link @click="toggleDropdown" :to="{name: 'password-reset'}" class="block p-3 pl-2 text-lg text-gray-800 hover:bg-gray-100" data-test="password-reset">
          Change Password
        </router-link>
      </div>
    </div>
</template>

<script>
import { CUSTOMER_IDS } from '@/constants'

export default {
  data () {
    return {
      showDropdown: false
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
    },
    handleClickOutside (e) {
      if (this.showDropdown && !this.$el.contains(e.target)) {
        this.showDropdown = false
      }
    }
  },
  computed: {
    isCitizenM () {
      return this.$store.getters['customers/customer'] && (this.$store.getters['customers/customer'].ID === CUSTOMER_IDS.CITIZENM)
    }
  }
}
</script>

<style>
.customer-switch {
  .multiselect {
    &-single-label {
      color: #03539c;
      font-size: 17px;
      font-weight: 500;
      cursor: pointer;

      .citizen-m & {
        color: #fff;
      }
    }

    &-clear {
      .citizen-m & {
        background: #000;
      }
    }

    &-option {
      transition: color, background-color .2s;

      &.is-pointed {
        background: #e1e8f6;

        .citizen-m & {
          background: #f56c6c;
        }
      }

      &.is-selected,
      &.is-pointed.is-selected {
        background: #03539c;
        color: #fff;

        .citizen-m & {
          background: #ff0038;
        }

        &.is-pointed {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
